import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token: string;
  domain = environment.apiURL;
  domainV2 = environment.apiURL;

  constructor(private router: Router, private http: HttpClient) {

  }

  createAuthenticationHeaders() {
    if (localStorage.getItem(environment.tokenKey)) {
      return { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': localStorage.getItem(environment.tokenKey) }) };
    }
    else {
      return { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    }
  }

  login(details) {
    return this.http.post(`${this.domainV2}users/login`, details);
  }

  forgotPassword(details) {
    details.bgColor = `#FF5722`
    return this.http.post(`${this.domain}users/forgotPassword`, details)
  }

  changePassword(details) {
    details.bgColor = `#FF5722`
    return this.http.post(`${this.domain}users/changePassword`, details, this.createAuthenticationHeaders())
  }

  checkEncryptedString(details) {
    return this.http.post(`${this.domain}users/checkEncryptedString`, details)
  }

  setNewPassword(details) {
    return this.http.post(`${this.domain}users/setNewPassword`, details)
  }

  getUserData(details) {
    return this.http.post(`${this.domain}users/me`, details, this.createAuthenticationHeaders())
  }


  //#region Trip

  trackTruck(details) {
    return this.http.post(`${this.domain}trips/trackTruck`, details);
  }

  createTrip(details) {
    return this.http.post(`${this.domain}trips/createTrip`, details, this.createAuthenticationHeaders())
  }

  getTrips(details) {
    return this.http.post(`${this.domain}trips/getTrips`, details, this.createAuthenticationHeaders())
  }

  deleteTrip(details) {
    return this.http.post(`${this.domain}trips/deleteTrip`, details, this.createAuthenticationHeaders())
  }

  editTrip(details) {
    return this.http.post(`${this.domain}trips/editTrip`, details, this.createAuthenticationHeaders())
  }
  closeTrip(details) {
    return this.http.post(`${this.domain}trips/closeTrip`, details, this.createAuthenticationHeaders())
  }

  approveTrip(details) {
    return this.http.post(`${this.domain}trips/approveTrip`, details, this.createAuthenticationHeaders())
  }

  addWebUnlockDetails(details) {
    return this.http.post(`${this.domain}trips/addWebUnlockDetails`, details, this.createAuthenticationHeaders())
  }

  addTripLocation(details) {
    return this.http.post(`${this.domain}trips/addLocationToTrip`, details, this.createAuthenticationHeaders())
  }

  addComments(details) {
    return this.http.post(`${this.domain}trips/addComments`, details, this.createAuthenticationHeaders())
  }

  getComments(details) {
    return this.http.post(`${this.domain}trips/getComments`, details, this.createAuthenticationHeaders())
  }

  getPayment(details) {
    return this.http.post(`${this.domain}trips/getPayment`, details, this.createAuthenticationHeaders())
  }

  getNoTrips(details) {
    return this.http.post(`${this.domain}trips/getNoTrips`, details, this.createAuthenticationHeaders())
  }

  addPayment(details) {
    return this.http.post(`${this.domain}trips/addPayment`, details, this.createAuthenticationHeaders())
  }

  getLocationPayments(details) {
    return this.http.post(`${this.domain}trips/getLocationPayments`, details, this.createAuthenticationHeaders())
  }

  getMarkersAllTripWise(details) {
    return this.http.post(`${this.domain}track/getMarkersAllTripWise`, details, this.createAuthenticationHeaders())
  }

  addDeviceToTrip(details) {
    return this.http.post(`${this.domain}trips/addDeviceToTrip`, details, this.createAuthenticationHeaders())
  }

  tripSendOTP(details) {
    return this.http.post(`${this.domain}trips/tripSendOTP`, details, this.createAuthenticationHeaders())
  }

  tripVerifyOTP(details) {
    return this.http.post(`${this.domain}trips/tripVerifyOTP`, details, this.createAuthenticationHeaders())
  }

  sendEmailToTeam(details) {
    return this.http.post(`${this.domain}trips/sendEmailToTeam`, details, this.createAuthenticationHeaders())
  }

  addFareDetailsWithoutTrip(details) {
    return this.http.post(`${this.domain}trips/addFareDetailsWithoutTrip`, details, this.createAuthenticationHeaders())
  }

  getOTPUnlockedDetails(details) {
    return this.http.post(`${this.domain}trips/getOTPUnlockedDetails`, details, this.createAuthenticationHeaders())
  }
  //#endregion Task

  //#region General
  uploadImage(details) {
    return this.http.post(`${this.domain}general/uploadImage`, details, this.createAuthenticationHeaders())
  }

  getImage(details) {
    return this.http.post(`${this.domain}general/getImage`, details, this.createAuthenticationHeaders())
  }

  getTansporters(details) {
    return this.http.post(`${this.domain}general/getTansporters`, details, this.createAuthenticationHeaders())
  }

  getMaterialType(details) {
    return this.http.post(`${this.domain}general/getMaterialType`, details, this.createAuthenticationHeaders())
  }

  downloadTrack(details) {
    return this.http.post(`${this.domain}general/downloadTrack`, details, this.createAuthenticationHeaders())
  }

  checkAvailibility(details) {
    return this.http.post(`${this.domain}general/checkAvailibility`, details, this.createAuthenticationHeaders())
  }
  //#endregion

  //#region Track
  getTrackData(details) {
    return this.http.post(`${this.domain}track/getTrackData`, details, this.createAuthenticationHeaders())
  }

  getTrackDataWithoutLogin(details) {
    return this.http.post(`${this.domain}track/getTrackDataWithoutLogin`, details)
  }

  getGeofenceWithoutLogin(details) {
    return this.http.post(`${this.domain}geofences/getGeofenceWithoutLogin`, details)
  }
  //#endregion

  //#region Alert
  sendManualAlert(details) {
    return this.http.post(`${this.domain}alert/sendManualAlert`, details, this.createAuthenticationHeaders())
  }

  getAlertLogs(details) {
    return this.http.post(`${this.domain}alert/getAlertLogs`, details, this.createAuthenticationHeaders())
  }

  getReceivers(details) {
    return this.http.post(`${this.domain}alert/getReceivers`, details, this.createAuthenticationHeaders())
  }

  addReceivers(details) {
    return this.http.post(`${this.domain}alert/addReceivers`, details, this.createAuthenticationHeaders())
  }

  deleteReceiver(details) {
    return this.http.post(`${this.domain}alert/deleteReceiver`, details, this.createAuthenticationHeaders())
  }

  getEventsLogs(details) {
    return this.http.post(`${this.domain}general/getEventsLogs`, details, this.createAuthenticationHeaders())
  }

  sendDataManually(details) {
    return this.http.post(`${this.domain}general/sendDataManually`, details, this.createAuthenticationHeaders())
  }

  //#endregion

  //#region geofence
  createGeofence(details) {
    return this.http.post(`${this.domain}geofences/createGeofence`, details, this.createAuthenticationHeaders())
  }

  getGeofence(details) {
    return this.http.post(`${this.domain}geofences/getGeofences`, details, this.createAuthenticationHeaders())
  }


  editGeofence(details) {
    return this.http.post(`${this.domain}geofences/editGeofence`, details, this.createAuthenticationHeaders())
  }

  deleteGeofence(details) {
    return this.http.post(`${this.domain}geofences/deleteGeofence`, details, this.createAuthenticationHeaders())
  }

  getCheckpoint(details) {
    return this.http.post(`${this.domain}geofences/getCheckpoints`, details, this.createAuthenticationHeaders())
  }

  getDistricts(details) {
    return this.http.post(`${this.domain}geofences/getDistricts`, details, this.createAuthenticationHeaders())
  }

  addDataForOTP(details) {
    return this.http.post(`${this.domain}geofences/addDataForOTP`, details, this.createAuthenticationHeaders())
  }

  saveRoute(details) {
    return this.http.post(`${this.domain}geofences/saveRoute`, details, this.createAuthenticationHeaders())
  }

  getRoute(details) {
    return this.http.post(`${this.domain}geofences/getRoutes`, details, this.createAuthenticationHeaders())
  }
  //#endregion

  //#region Asset

  //#region Permission

  getUserPermission(details) {
    return this.http.post(`${this.domain}permissions/getAllPermissions`, details, this.createAuthenticationHeaders())
  }

  //#endregion
  addAsset(details) {
    return this.http.post(`${this.domain}asset/addAsset`, details, this.createAuthenticationHeaders())
  }

  getAssetList(details) {
    return this.http.post(`${this.domain}asset/getAssets`, details, this.createAuthenticationHeaders())
  }

  getAssetType(details) {
    return this.http.post(`${this.domain}asset/getAssetType`, details, this.createAuthenticationHeaders())
  }

  deleteAsset(details) {
    return this.http.post(`${this.domain}asset/deleteAsset`, details, this.createAuthenticationHeaders())
  }

  editAssetDetails(details) {
    return this.http.post(`${this.domain}asset/editAssetDetails`, details, this.createAuthenticationHeaders())
  }

  addAssetDetails(details) {
    return this.http.post(`${this.domain}asset/addAssetDetails`, details, this.createAuthenticationHeaders())
  }

  bulkUploadAsset(details) {
    return this.http.post(`${this.domain}asset/bulkUpload`, details, this.createAuthenticationHeaders())
  }

  getCommands(details) {
    return this.http.post(`${this.domain}asset/getCommands`, details, this.createAuthenticationHeaders())
  }

  getCommand(details) {
    // this.domain +  
    return this.http.post(`${this.domain}asset/getLogsForCommand`, details, this.createAuthenticationHeaders());
  }

  //#endregion

  sendCommand(obj) {
    return this.http.post(`${this.domain}trips/sendDeviceCommand`, obj, this.createAuthenticationHeaders());
  }


  //#region 

  addUser(details) {
    return this.http.post(`${this.domain}user/addUser`, details, this.createAuthenticationHeaders())
  }

  addUserWithoutLogin(details) {
    return this.http.post(`${this.domain}user/addUserWithoutLogin`, details)
  }

  getUser(details) {
    return this.http.post(`${this.domain}user/getUsers`, details, this.createAuthenticationHeaders())
  }

  deleteUser(details) {
    return this.http.post(`${this.domain}user/deleteUser`, details, this.createAuthenticationHeaders())
  }

  linkUser(details) {
    return this.http.post(`${this.domain}user/linkUser`, details, this.createAuthenticationHeaders())
  }

  approveUser(details) {
    return this.http.post(`${this.domain}user/approveUser`, details, this.createAuthenticationHeaders())
  }

  updateUser(details) {
    return this.http.post(`${this.domain}user/updateUser`, details, this.createAuthenticationHeaders())
  }

  updateUserPermissions(details) {
    return this.http.post(`${this.domain}user/updateUserPermissions`, details, this.createAuthenticationHeaders())
  }

  sendOTP(details) {
    return this.http.post(`${this.domain}users/sendOTP`, details, this.createAuthenticationHeaders())
  }

  verifyOTP(details) {
    return this.http.post(`${this.domain}users/verifyOTP`, details, this.createAuthenticationHeaders())
  }

  //#endregion

  // #monitoring region
  getCountLocationWise(details) {
    return this.http.post(`${this.domain}monitoring/getCountLocationWise`, details, this.createAuthenticationHeaders())
  }

  updateAssetHelper(details) {
    return this.http.post(`${this.domain}monitoring/updateAssetHelper`, details, this.createAuthenticationHeaders())
  }

  getDataLocationWise(details) {
    return this.http.post(`${this.domain}monitoring/getDataLocationWise`, details, this.createAuthenticationHeaders())
  }
  getLocationStatusData(details) {
    return this.http.post(`${this.domain}monitoring/getLocationStatusData`, details, this.createAuthenticationHeaders())
  }
  deviceRunningWithoutTrip(details) {
    return this.http.post(`${this.domain}monitoring/deviceRunningWithoutTrip`, details, this.createAuthenticationHeaders())
  }

  updateLocationToDevice(details) {
    return this.http.post(`${this.domain}monitoring/updateLocationToDevice`, details, this.createAuthenticationHeaders());
  }

  getDeviceWiseStatus(details) {
    return this.http.post(`${this.domain}monitoring/getDeviceWiseStatus`, details, this.createAuthenticationHeaders());
  }

  getLocationWiseStatus(details) {
    return this.http.post(`${this.domain}monitoring/getLocationWiseStatus`, details, this.createAuthenticationHeaders());
  }
  // #endregion

  logout() {
    localStorage.removeItem(environment.tokenKey)
    this.router.navigate(['/']);
  }


}
